import { Vector2 } from "three";
import { ElementType } from "../../../dom-tools/ElementType";
import { ComparableUIProperty, UIProperty } from "../../../dom-ui/basics/UIProperty";
import { ScrollBar } from "../../../dom-ui/components/ScrollBar";
import { ScrollBarPositions, ScrollViewBase } from "../../../dom-ui/components/ScrollViewBase";
import { Grid } from "../../../dom-ui/graphical/Grid";
import { MathV } from "../../../math/MathV";
import { ComposerGrid } from "./ComposerGrid";

export class NotesEditor extends ScrollViewBase
{
  static readonly elementType = new ElementType( "composer-notes-editor" );

  grid = new ComposerGrid();
  xScrollRange = new ComparableUIProperty( this, new Vector2( 0, 16 ) );
  xSizeRange   = new UIProperty( this, new Vector2( 4, 16 ) );

  yScrollRange = new ComparableUIProperty( this, new Vector2( 32, 32 + 12 * 3 ) );
  ySizeRange   = new UIProperty( this, new Vector2( 4, 6 ) );
  

  _createElement()
  {
    this._setElement( NotesEditor.elementType.create() );  

    this.scrollBarPositions.value = ScrollBarPositions.TOP_RIGHT;    
  }

  constructor()
  {
    super();

    this.grid.dimensions.set( 0, 0, 1000, 1000 );

    // this.verticalScrollBar.value.zoomEnabled.value = true;
    // this.horizontalScrollBar.value.zoomEnabled.value = true;

    this.scrollContainer.value.content.value = this.grid;

    this.horizontalScrollBar.value.offset.addListener(
      ()=>
      {
        this.#computeHorizontalRanges();
        this.grid.redraw();
      }
    );

    this.horizontalScrollBar.value.zoom.addListener(
      ()=>
      {
        this.#computeHorizontalRanges();
        this.grid.redraw();
      }
    );

    this.horizontalScrollBar.value.zoomEnabled.value = true;
    this.verticalScrollBar.value.zoomEnabled.value   = true;

    this.verticalScrollBar.value.offset.addListener(
      ()=>
      {
        this.#computeVerticalRanges();
        this.grid.redraw();
      }
    );

    this.verticalScrollBar.value.zoom.addListener(
      ()=>
      {
        this.#computeVerticalRanges();
        this.grid.redraw();
      }
    )

    this.#computeHorizontalRanges();
    this.#computeVerticalRanges();
  }

  #computeRanges( scrollBar:ScrollBar, sizeRange:Vector2, scrollRange:Vector2, x:boolean )
  {
    let zoom   = scrollBar.zoom.value;
    let offset = 1 - scrollBar.offset.value;

    let size     = MathV.lerpClampedAsRange( sizeRange, zoom );
    let position = MathV.lerpClampedAsRange( scrollRange, offset );

    if ( x )
    {
      this.grid.min.value.x = position - size;
      this.grid.max.value.x = position + size;
    }
    else
    {
      this.grid.min.value.y = position - size;
      this.grid.max.value.y = position + size;
    }


    console.log( { zoom, offset, size, position } );
  }

  #computeHorizontalRanges()
  {
    this.#computeRanges( 
      this.horizontalScrollBar.value, 
      this.xSizeRange.value, this.xScrollRange.value,
      true
    );
  }

  #computeVerticalRanges()
  {
    this.#computeRanges( 
      this.verticalScrollBar.value, 
      this.ySizeRange.value, this.yScrollRange.value,
      false
    );
  }

  _update()
  {
    super._update();

    if ( this.scrollContainer.value && this.scrollContainer.value.content.value )
    { 
      this.scrollContainer.value.content.value.dimensions.setFrom( this.scrollContainer.value.dimensions );
    }    
  }
}